import type { MapLibraries } from './_types';
import L from 'leaflet';
import * as proj4 from 'proj4';
import * as turf from '@turf/turf';
import 'leaflet/dist/leaflet.css';
import markerIcon2xUrl from 'leaflet/dist/images/marker-icon-2x.png';
import markerIconUrl from 'leaflet/dist/images/marker-icon.png';
import markerShadowUrl from 'leaflet/dist/images/marker-shadow.png';

/**
 * Return bundled mapping libraries without CDN requests.
 */
export const ensureMapLibraries = async (): Promise<MapLibraries | null> => {
  const proj4Api = (proj4 as any).default ?? proj4;

  // Disable Leaflet auto path detection, which can break behind custom base URLs.
  delete (L.Icon.Default.prototype as any)._getIconUrl;

  // Ensure default Leaflet marker assets are resolved by the bundler.
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2xUrl,
    iconUrl: markerIconUrl,
    shadowUrl: markerShadowUrl
  });

  return {
    L,
    proj4: proj4Api,
    turf
  };
};
